// ** Icons Import
import { List, Home, BarChart2, UploadCloud, Eye, Book, Layers, Loader, Sliders, Settings, Users} from 'react-feather'

export default [
  {
    id: 'home',
    title: 'Home',
    icon: <Home size={20} />,
    navLink: '/home',
    action: 'read',
    resource: 'core'
  },
  {
    header: 'Data',
    action: 'read',
    resource: 'data'
  },
  {
    id: 'acquire',
    title: 'Acquire',
    icon: <UploadCloud size={20} />,
    navLink: '/data-acquire',
    action: 'read',
    resource: 'acquire'
  },
  {
    id: 'Consult',
    title: 'Consult',
    icon: <Eye size={20} />,
    children: [
      {
        id: 'dataRegulation',
        title: 'Regulation',
        icon: <Book size={16} />,
        navLink: '/data-regulation',
        action: 'read',
        resource: 'company'
      },      {
        id: 'dataCompany',
        title: 'Company',
        icon: <Layers size={16} />,
        navLink: '/data-company',
        action: 'read',
        resource: 'company'
      },
      {
        id: 'dataEmployees',
        title: 'Employees',
        icon: <Users size={16} />,
        navLink: '/data-employees',
        action: 'read',
        resource: 'employees'
      }
    ]
  },
  {
    header: 'Analytic',
    action: 'read',
    resource: 'analytic'
  },
  {
    id: 'analyticCreate',
    title: 'Create',
    icon: <Loader size={20} />,
    navLink: '/analytic-create',
    action: 'create',
    resource: 'analytic'
  },
  {
    id: 'analyticConsult',
    title: 'Consult',
    icon: <Eye size={20} />,
    action: 'read',
    resource: 'analytic',
    children: [
      {
        id: 'analyticReport',
        title: 'Report',
        action: 'read',
        resource: 'analytic',
        icon: <List size={16} />,
        navLink: '/analytic-report'
      },      {
        id: 'analyticChart',
        title: 'Chart',
        action: 'read',
        resource: 'analytic',
        icon: <BarChart2 size={16} />,
        navLink: '/analytic-chart'
      }
    ]
  },
  {
    header: 'Budget',
    action: 'read',
    resource: 'budget'
  },
  {
    id: 'simulation',
    title: 'Simulate',
    action: 'create',
    resource: 'budget',
    icon: <Sliders size={20} />,
    navLink: '/simulation'
  },
  {
    id: 'budget',
    title: 'Manage',
    action: 'create',
    resource: 'budget',
    icon: <BarChart2 size={20} />,
    navLink: '/budget'
  }
]
